import React from 'react';
import Box from '@mui/material/Box';
import WorkFlowPage from './WorkFlowPage';

const WorkflowMain: React.FC = () => {
  return (
    <Box sx={{
      flexGrow: 1,
      backgroundColor: '#F7F9FA',
      padding: '0.5rem',
    }}>
      <WorkFlowPage />
    </Box>
  );
};

export default WorkflowMain;